import { render, staticRenderFns } from "./Iframe.vue?vue&type=template&id=01b53922&"
import script from "./Iframe.vue?vue&type=script&lang=ts&"
export * from "./Iframe.vue?vue&type=script&lang=ts&"
import style0 from "./Iframe.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports